import { plural, t } from "@lingui/core/macro";
import {
  differenceInCalendarDays,
  isYesterday,
  isTomorrow,
  isToday,
  startOfToday,
} from "date-fns";
import { humanFormat } from "@medoma/models/date-and-time";

const dateAndMonthFormatOptions = {
  month: "long" as const,
  day: "numeric" as const,
};
const dayDateAndMonthFormatOptions = {
  weekday: "long" as const,
  month: "long" as const,
  day: "numeric" as const,
};
const dateMonthAndYearFormatOptions = {
  day: "numeric" as const,
  month: "numeric" as const,
  year: "numeric" as const,
};

export const dateMonthAndYear = (date: Date) => {
  return humanFormat(date, dateMonthAndYearFormatOptions);
};

export const dateName = (date: Date) => {
  const dateAndMonth = humanFormat(date, dateAndMonthFormatOptions);
  if (isToday(date)) {
    return `${t`Idag`}, ${dateAndMonth}`;
  }

  if (isTomorrow(date)) {
    return `${t`Imorgon`}, ${dateAndMonth}`;
  }

  if (isYesterday(date)) {
    return `${t`Igår`}, ${dateAndMonth}`;
  }

  const dayDateAndMonth = humanFormat(date, dayDateAndMonthFormatOptions);
  return dayDateAndMonth.charAt(0).toUpperCase() + dayDateAndMonth.slice(1);
};

export const daysAgo = (date: Date) => {
  const daysSinceDate = differenceInCalendarDays(startOfToday(), date);
  return plural(daysSinceDate, {
    0: "idag",
    1: "igår",
    other: "# dagar sedan",
  });
};
